
import React, {FC, InputHTMLAttributes} from 'react';
import classNames from 'classnames';
import {Field, FieldProps} from 'formik';

import * as shared from 'components/Controls/shared.module.scss';

interface InputProps extends InputHTMLAttributes<object> {
	name: string;
}

export const Input: FC<InputProps> = (props) => {
	const {className, ...rest} = props;

	if (!props.name) {
		return (
			<input
				className={classNames(shared.input, className)}
				{...rest}
			/>
		);
	}

	return (
		<Field name={props.name}>
			{({field, meta}: FieldProps) => (
				<div className={shared.wrapper}>
					<input
						className={classNames(shared.input, className)}
						{...field}
						{...rest}
					/>
					{meta.touched && meta.error && (
						<div className={shared.error}>
							{meta.error}
						</div>
					)}
				</div>
			)}
		</Field>
	);
};

